<template>
  <div class="w-full items-center">
    <div class="w-full lg:w-1/2 md:w-1/2">
      <div class="router-header flex flex-wrap items-center mb-3">
        <div
          class="content-area__heading pr-4"
        >
          <h4 class="mb-1">{{ $t("mySkills.ms1") }}</h4>
          <!--<div class="mt-2 mb-1">Select one to continue</div>-->
        </div>
      </div>
      <div v-if="completed.length === 0 && inProgress.length === 0">
        <div
          class="con-vs-avatar mx-auto my-6 block 80px"
          style="width: 250px; height: 200px; background: white/*rgb(195, 195, 195)*/;"
        >
          <!---->
          <div class="">
            <img
              src="@/assets/Illustrations/Ill_History.svg"
              alt=""
              style="color: grey;"
            />
          </div>
        </div>
        <div class="p-6 text-center">
          <!--<span
            class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning mb-4"
            style="background: rgba(var(&#45;&#45;vs-primary),0.15);"
          >
            <img src="@/assets/Illustrations/Ill_Skill Details_Progress.svg" alt="attribute" class="skill-icon" />
          </span>-->
          <div class="truncate t-sd mb-base">
            <h5 class="mb-2" style="color: #079E9A;">
              {{ $t("mySkills.ms2") }}
            </h5>
            <span>{{ $t("mySkills.ms3") }}</span>
          </div>
          <vs-button @click="addSkill">{{ $t("mySkills.ms4") }}</vs-button>
        </div>
        <!---->
      </div>
      <div v-else class="vs-tabs-div">
      <vs-tabs class="vs-tabs-group" style=" background: rgba(var(--vs-primary),0.25);" alignment="fixed">
        <vs-tab :label="$t('mySkills.ms5')">
          <div>
            <InProgress :inProgress="inProgress" />
          </div>
        </vs-tab>
        <vs-tab :label="$t('mySkills.ms6')">
          <div>
            <Completed :completed="completed" />
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
    </div>
  </div>
</template>

<script>
// import ccd from "@/assets/data/charactersistic-competency-definition";
import InProgress from "./InProgress";
import Completed from "./Completed.vue";
// Store Module
// import moduleAddSkill from "@/store/add-skill/moduleCompetencyProgress.js";

export default {
  name: "MySkills",
  data() {
    return {
      allCompetencies: [],
      CCD: this.$t("addNewSkill.data"),
      completed: [],
      inProgress: []
    };
  },
  components: {
    InProgress,
    Completed
  },
  created() {},
  methods: {
    addSkill () {
      this.$router.push("add-skill")
    }
  },
  mounted() {
    let data= JSON.parse(localStorage.getItem('userInfo'));

    const query = {
      usersId: data.usersId
    };
    this.$store
      .dispatch("trainee-competencies/find", { query })
      .then(res => {
        // this.allCompetencies = res.data;
        for (const comp in res.data) {
          console.log(res.data[comp]);
          const compId = res.data[comp].competencyId.split("-");
          const compDetails = this.CCD[compId[0]].competencies[compId[1]];
          console.log(compDetails);
          if (res.data[comp].progressStatus === "in_progress") {
            this.inProgress.push({
              i: res.data[comp].id,
              id: compDetails.id,
              comp: compDetails.comp,
              icon: compDetails.icon,
              wdd: compDetails.wdd
            });
          } else if (res.data[comp].progressStatus === "complete") {
            this.completed.push({
              i: res.data[comp].id,
              id: compDetails.id,
              comp: compDetails.comp,
              icon: compDetails.icon,
              wdd: compDetails.wdd
            });
          }
        }
      })
      .catch(err => {
        console.log("could not find trainee competencies", err);
      });
  }
};
</script>

<style scoped>
.con-vs-card >>> .vs-card--content {
  padding: 3px 8px 3px 8px !important;
  margin-bottom: 10px;
}
.items-center{
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}

</style>
